import React from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';

/**
 * Sparkline
 * Minimal inline trend line — no axes, no grid, no tooltip.
 * Returns null when there is not enough data to draw a line.
 *
 * Props:
 *   data: number[]
 *   height: number (default 40)
 *   color: string (default '#6b7280')
 *   ariaLabel: string
 */
export default function Sparkline({ data, height = 40, color = '#6b7280', ariaLabel }) {
  if (!Array.isArray(data) || data.length < 2) return null;

  const chartData = data.map((v, i) => ({ i, v }));

  return (
    <div className="w-full" style={{ height }} role="img" aria-label={ariaLabel}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 2, right: 0, left: 0, bottom: 2 }}>
          <Line
            type="monotone"
            dataKey="v"
            stroke={color}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
